import React, { Fragment, useEffect, useRef, useState } from "react";
import { Form, Table } from "react-bootstrap";
// import { motion } from "framer-motion";
import API from "../../services/axiosInstance";
import Pagination from "../common_modules/pagination";
import { Link, redirect, useNavigate } from "react-router-dom";
import { LuPenLine, LuTrash2, LuPlus } from "react-icons/lu";
import './user.css'
import { lastPage } from "../utils/helper";
import FilterBar from "../common_modules/filter";
import { AUTH_CODE } from "../security/authCodes";
import Permission from "../security/permission";
import { useAuth } from "../security/authContext";
import { FormLoader, useFormLoader } from "../common_modules/loader";
import { SearchIcon } from "../common_modules/commonIcons";

const UserListing = () => {
    const [list, setList] = useState([]);
    const [paginationData, setpaginationData] = useState({});
    const [accountList, setAccountList] = useState([]);
    const [searchConfig, setSearchConfig] = useState();

    // global data
    const tableFields = [
        { label: "Id", value: "id", enableSorting: true, enableIcon: true },
        { label: "Name", value: "name", enableSorting: true, enableIcon: true },
        { label: "User Id", value: "userName", enableSorting: true, enableIcon: true },
        { label: "Account", value: "account", enableSorting: false, enableIcon: false },
        { label: "Role", value: "role", enableSorting: false, enableIcon: false },
        { label: "Status", value: "status", enableSorting: false, enableIcon: false },
    ];

    // hooks
    const navigate = useNavigate();
    const { hasPermission } = useAuth();
    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook

    const userList = async (search, page, field = "", order = "") => {
        startLoading();
        try {
            const size = 100;
            const res = await API.get(`/tech/users/user/list?search=${search}&page=${page}&size=${size}&field=${field}&order=${order}`);
            const data = res?.data?.data?.content;
            if (res.status === 200 && data) {
                // set user account name by user account id
                let userAccounts = await userAccountList();
                const accountMap = Object.fromEntries(
                    userAccounts.map(e => [e.id, e.name])
                );
                data.forEach(x => {
                    x.accountType =
                        x.accountType === 0
                            ? "Admin"
                            : accountMap[x.accountType] ?? x.accountType;
                });

                setList(data);
                // save pagination information
                let pagination = res.data.data;
                delete pagination.content; //  remove data
                setpaginationData(pagination);
            } else {
                setList([]);
                setpaginationData({});
            }
        } catch (error) { } finally {
            stopLoading();
        }
    }

    const nextPage = (nextPage) => {
        userList("", nextPage, searchConfig?.orderField, searchConfig?.orderDir)
    }

    const updateUser = (id) => {
        navigate(`/user/${id}`)
    }

    const activateDeactivate = async (item) => {
        startLoading();
        try {
            if (window.confirm(`Do you want to ${item.status == 1 ? "Deactivate" : "Active"} this user !!!`)) {
                let response = await API.put(`/tech/users/user/${item.id}/status`)
                if (response.status == 200) {
                    // alert(`${response.data.message} Successfully...`);
                    nextPage(lastPage(UserListing.name));
                }
            }
        } catch (error) { } finally {
            stopLoading();
        }

    }

    const userAccountList = async () => {
        startLoading();
        try {
            const accTypeRes = await API.get('tech/users/user/accounts/list');
            if (accTypeRes.status === 200) {
                const result = accTypeRes?.data?.data;
                setAccountList(result);
                return result;
            }
        } catch (error) { } finally {
            stopLoading();
        }

        return false;
    }

    const onChangeSearch = (params) => {
        setSearchConfig(params)
        userList(params.keyword, 0, params.orderField, params.orderDir); // API call
    }

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="">
                <div className="breadCrumb gradient-bg">
                    <Link to={'/dashboard'}><span>Home</span></Link>
                    <span>User</span>
                    <span>User Listing</span>
                </div>   
                <h4 className="my-4">🧾 User List</h4>
                {/* <div className="active-table-wrapper">
                    <div style={{
                        paddingBottom: "0.8rem",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}> */}
                <div className="filter row">
                    <Permission code={AUTH_CODE.user.create}>
                        <Link
                            to={"/user/add"}
                            className="btn btn-primary btn-md addBtn"
                            style={{ whiteSpace: "nowrap" }}>
                            Create User <LuPlus />
                        </Link>
                    </Permission>

                    <Permission code={AUTH_CODE.user.listing}>
                        <FilterBar fields={tableFields} onSearch={onChangeSearch} />
                    </Permission>
                </div>
                {/* </div> */}
                <Permission code={AUTH_CODE.user.listing}>
                    <div className="mt-0 table-wrapper mt-3">
                        <Table striped bordered responsive hover size="sm" className="custom-table align-middle">
                            <thead>
                                <tr>
                                    <th>☰</th>
                                    {
                                        tableFields?.map((item, i) => (
                                            <th key={i}>
                                                {item.label}
                                                {item.enableIcon ? <SearchIcon className="ms-1" size={10} fill="white" /> : ""}
                                            </th>
                                        ))
                                    }
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            {
                                list.length > 0 ?

                                    <tbody>
                                        {
                                            list.length > 0 &&
                                            list.map((item, index) => {
                                                return (
                                                    <tr key={index} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 * index }} className="hover-glow">
                                                        <td>{(paginationData.number * paginationData.size) + (index + 1)}</td>
                                                        <td>{item.id}</td>
                                                        <td>
                                                            {
                                                                hasPermission(AUTH_CODE.user.editUpdate) ?
                                                                    <div title={item?.name} onClick={() => navigate(`/user/${item.id}`)}>
                                                                        <Link style={{ textDecoration: "none" }}>
                                                                            {item?.name?.length > 20
                                                                                ? item?.name.substring(0, 20) + "..."
                                                                                : item?.name}
                                                                        </Link>
                                                                    </div>
                                                                    : <div title={item?.name}>
                                                                        {item?.name?.length > 20
                                                                            ? item?.name.substring(0, 20) + "..."
                                                                            : item?.name}
                                                                    </div>
                                                            }
                                                        </td>
                                                        <td>{item.userId}</td>
                                                        <td>{item.accountType}</td>
                                                        <td>
                                                            {
                                                                hasPermission(AUTH_CODE.userRole.userRoleSetting) ?
                                                                    // item.accountType !== "Admin" ?
                                                                    <div title={item?.name} >
                                                                        <Link style={{
                                                                            textDecoration: "none"
                                                                        }} to={`/role/${item.customRoleId}`} state={{ redirectPage: "/user" }}>
                                                                            <span title={item?.customRole}>
                                                                                {item?.customRole?.length > 20
                                                                                    ? item?.customRole.substring(0, 20) + "..."
                                                                                    : item?.customRole}
                                                                            </span>
                                                                        </Link>
                                                                    </div>
                                                                    // : "--"
                                                                    :
                                                                    // item.accountType !== "Admin" ?
                                                                    <div title={item?.customRole}>
                                                                        {item?.customRole?.length > 20
                                                                            ? item?.customRole.substring(0, 20) + "..."
                                                                            : item?.customRole}
                                                                    </div>
                                                                // : "--"
                                                            }
                                                        </td>
                                                        <td style={{ textAlign: "center" }}>
                                                            <span className={`badge ${item?.status === 1 ? "active" : "inactive"}`}>
                                                                {item?.status === 1 ? "Active" : "Inactive"}
                                                            </span>
                                                        </td>
                                                        <td className="activePubAllBtns">
                                                            <Permission code={AUTH_CODE.user.editUpdate}>
                                                                <button onClick={(e) => updateUser(item.id)}><LuPenLine /> Edit</button>
                                                            </Permission>
                                                            <Permission code={AUTH_CODE.user.activateDeactivate}>
                                                                <button onClick={(e) => activateDeactivate(item)}><LuTrash2 /> {item.status == 1 ? "Deactivate" : "Active"}</button>
                                                            </Permission>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        }
                                    </tbody>

                                    : ""
                            }
                        </Table>
                        {
                            list.length <= 0 && <center>No Data Found !!!</center>
                        }
                    </div>

                    {/* pagination */}
                    <Pagination
                        initCall={true}
                        jumpPage={true}
                        count={true}
                        component={UserListing.name}
                        size={"sm"}
                        paginationData={paginationData}
                        nextPage={nextPage} />
                </Permission>
                {/* </div> */}
            </div>
        </FormLoader>
    );
};

export default UserListing;
